export function imageEncode(arrayBuffer, mimeType) {
  let b64encoded = Buffer.from(arrayBuffer, "binary").toString("base64");

  return `data:${mimeType};base64,${b64encoded}`;
}
